export enum EndpointListEvents {
  SEARCH_ENDPOINT = 'searchEndpoint',
  ENDPOINT_SELECTION_CHANGED = 'endpointChanged',
  SEARCH_CLEAR = 'searchClear',
}

export const ENDPOINT_LIST_ID = 'endpoints-filter-list';
